import React from 'react'
import { colors } from 'config/ui'
import { StyledIconButton } from './IconButton.styles'
import { buttonPropTypes } from './Button'
import { Spinner } from 'components/lib/loaders'

const IconButton = ({
  primary = undefined,
  color = undefined,
  disabled = undefined,
  loading = undefined,
  children = undefined,
  ...rest
}) => (
  <StyledIconButton
    data-testid="icon-button"
    type="button"
    color={primary ? colors.primary : color || colors.gray}
    disabled={loading || disabled}
    {...rest}
  >
    {loading ? <Spinner /> : children}
  </StyledIconButton>
)

IconButton.propTypes = buttonPropTypes

IconButton.defaultProps = {
  size: 'medium'
}

export default IconButton
